import React, {useEffect, useState} from 'react';
import {useParams, useLocation} from 'react-router-dom';
import {Link} from 'react-router-dom';

function Profile(props) {
    const [on,setOn] = useState(false);
    const location = useLocation();
    const locationNum = location.pathname.split("/");
    useEffect(() => {
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        if(locationNum[1] !== props.pageN.page) props.pageF(locationNum[1]);
        console.log(props.pageN.conBox)
        //props.pageN.conBox.current.scrollTo({ top: 0, behavior: 'auto' });
        const timeOut = setTimeout(()=> setOn(true), 100);
        return () => clearTimeout(timeOut);
    });
    return (
        <div className={on ? "conBox on" : "conBox"}>
            <div className="topBg"></div>
            <div className="conTopWave">
                <div className="conTopWaveIn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="6000" height="240" viewBox="0 0 6000 240" preserveAspectRatio="xMidYMid slice">
                        <pattern id="wave" width=".25" height="1.1" patternContentUnits="objectBoundingBox">
                        <path fill="#1A2C2D" d="M0.25,1H0c0,0,0-0.659,0-0.916c0.083-0.303,0.158,0.334,0.25,0C0.25,0.327,0.25,1,0.25,1z"></path>
                        </pattern>
                        <rect width="6000px" height="140"></rect>
                    </svg>
                </div>
            </div>
            <div className="pageNameBox">
                <div className="pageNameBoxIn">
                    <h2>PROFILE</h2>
                    <p>Kang, deokwon</p>
                </div>
            </div>
            
            <div className="profileMovieBox">
                <video loop autoPlay muted playsInline poster={process.env.PUBLIC_URL+"/assets/img/profile/profile.jpg"} preload="auto">
                    <source src={process.env.PUBLIC_URL+"/assets/img/profile/profile.mp4"} type="video/mp4" />
                    <p><img src={process.env.PUBLIC_URL+"/assets/img/profile/profile.jpg"} alt="" /></p>
                </video>
            </div>
            <div className="conInBox">
                <h2><img src="../../name.svg" alt="Kang, deok won" /></h2>
                <p>
                    'Simulacre'를 주제로 꾸준한 작품활동을 하고 있으며, 사진을 통한 '빛'에 대한 탐구를 지속하고 있다. '빛은 성당이 되었다'라는 저서를 출간하였으며 현재는 IT에 종사하며 웹서비스 팀장을 수행하고 있다. 
                </p>
                <ul className="conInTextList">
                    <li><div>2022</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Winner - Hyundai Steel, ESG Report 2022</strong>
                        <span>웹어워드 대상 - 	현대제철 지속가능경영보고서 2022</span>
                    </li>
                    <li><div>2022</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Winner - Personal Information Protection Portal</strong>
                        <span>웹어워드 대상 - 	개인정보보호 포털</span>
                    </li>
                    <li><div>2022</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Winner - National Institute of Environmental Research</strong>
                        <span>웹어워드 대상 - 	국립환경과학원</span>
                    </li>
                    <li><div>2021</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Total Winner - Hyundai Steel, ESG Report 2021</strong>
                        <span>웹어워드 통합대상 - 	현대제철 지속가능경영보고서 2021</span>
                    </li>
                    <li><div>2019</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Total Winner - PAGODA</strong>
                        <span>웹어워드 통합대상 - 	파고다 어학원 대표홈페이지</span>
                    </li>
                    <li><div>2019</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Total Winner - National Institute of Environmental Research</strong>
                        <span>웹어워드 대상 - 	국립환경과학원</span>
                    </li>
                    <li><div>2018</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Finalist - National Institute of Biological Resources</strong>
                        <span>웹어워드 대상 - 	국립생물자원관 대표 홈페이지</span>
                    </li>
                    <li><div>2018</div>
                        <strong>Solo Exhibition - The light has become a cathedral.</strong>
                        <span>개인전 - 빛은 성당이 되었다.</span>
                    </li>
                    <li><div>2018</div>
                        <strong>BOOKS - The light has become a cathedral.(B&C BOOKS)</strong>
                        <span>저서 - 빛은 성당이 되었다.(B&C BOOKS)</span>
                    </li>
                    <li><div>2017</div>
                        <strong><img src={process.env.PUBLIC_URL+"/assets/img/common/wa.png"} className="iconWa" alt="web award" /> Web Award Finalist - caihong(daekyo)</strong>
                        <span>웹어워드 대상 - 차이홍(대교)</span>
                    </li>
                    <li><div>2017</div>
                        <strong>Group Exhibition - road with road</strong>
                        <span>7인 그룹전 - 길있는 길</span>
                    </li>
                   
                    <li><div>2013</div>
                        <strong>Education : Interaction design process considering web accessibility (KCCI)</strong>
                        <span>교육 : 웹접근성을 고려한 인터랙션 디자인 과정(대한상공회의소)</span>
                    </li>
                    <li><div>2013</div>
                        <strong>Achievement : data processing engineer(HRDK)</strong>
                        <span>국가기술작격 : 정보처리 기사(한국산업인력공단)</span>
                    </li>
                    <li><div>2008</div>
                        <strong>Escape from Space (Vision gallery, New York)</strong>
                        <span>Escape from Space(비전 갤러리, 뉴욕)</span>
                    </li>
                    <li><div>2008</div>
                        <strong>New merit (Shin Museum, Chongju)</strong>
                        <span>New merit (신미술관, 청주)</span>
                    </li>
                    <li><div>2007</div>
                        <strong>Young StarsⅣ (gallery Young, Seoul)</strong>
                        <span>Young StarsⅣ (갤러리 영, 서울)</span>
                    </li>
                    <li><div>2007</div>
                        <strong>Graduation Works Exhibition (Chongju)</strong>
                        <span>졸업 작품전 (청주)</span>
                    </li>
                    <li><div>2006</div>
                        <strong>The 10th world Peace Art Exhibition - Special Choice</strong>
                        <span>제 10회 세계평화미술대전 특선</span>
                    </li>
                    <li><div>2006</div>
                        <strong>The 9th world Peace Art Exhibition</strong>
                        <span>제 9회 세계평화미술대전 입선</span>
                    </li>
                </ul>
                <div className="manBox">
                    <img src={process.env.PUBLIC_URL+"/assets/img/common/man2.png"} alt="" className="manHead" />
                    <img src={process.env.PUBLIC_URL+"/assets/img/common/man.png"} alt="" className="manBody" />
                </div>
            </div>
        </div>
    );
};

export default Profile;